import { combineReducers } from "redux";

const authReducer = (state = [], action) => {
  switch (action.type) {
    case "LOGIN":
          return { username: action.payload.username, token: action.payload.token, refresh: action.payload.refresh };
    case "LOGOUT":
      return {};
    default:
      return state;
  }
};

const headerReducer = (state = { isOpen: false, brandImg: null }, action) => {
  switch (action.type) {
    case "TRIGGER_SIDEBAR_MENU":
          return {...state, isOpen: action.payload };
    case "SET_BRAND_IMG":
          return {...state, brandImg: action.payload };
    default:
      return state;
  }
};


const stateReducer = (state = [{ showReadonly: false }],action) => {
    switch (action.type) {
        case "TRIGGER_READONLY_POPUP":
            return { showReadonly: action.payload };
        default:
            return state;
    }
};

const extensionReducer = (
  state = {
    activeExtension: null,
    extensions: [],
    domain: ['*']
  },
  action
) => {
  switch (action.type) {
    case "SET_ACTIVE_EXTENSION":
      return { ...state, activeExtension: action.payload };
    case "SET_DOMAIN":
      return { ...state, domain: action.payload };
    case "SET_EXTENSIONS":
      return { ...state, extensions: action.payload };
    default:
      return state;
  }
};

const saasReducer = (
  state = {
    activeSaas: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_ACTIVE_SAAS":
      return { ...state, activeSaas: action.payload };
    default:
      return state;
  }
};

const commonReducer = (
  state = {
    showTooltip: false,
    tooltipText: '',
    tooltipCoords: { x: 0, y: 0 },
  },action) => {
    switch (action.type) {
    case "SET_SHOW_TOOLTIP":
      return { ...state, showTooltip: action.payload };
    case "SET_TOOLTIP_TEXT":
      return { ...state, tooltipText: action.payload };
    case "SET_TOOLTIP_COORDS":
      return { ...state, tooltipCoords: action.payload };
    default:
      return state;
  }}

const policyReducer = (
  state = {
    categoriesGroups: null,
    rawList: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_RAW_LIST":
      return { ...state, rawList: action.payload };
    case "SET_CATEGORIES_GROUPS":
      return { ...state, categoriesGroups: action.payload };
    default:
      return state;
  }
};


const rootReducer = combineReducers({
    auth: authReducer,
    header: headerReducer,
    states: stateReducer,
    extension: extensionReducer,
    saas: saasReducer,
    common: commonReducer,
    policy: policyReducer
});


export default rootReducer;
